import { environment } from "../environment";
import { AsyncResult } from "../models/common/async-result";
import api from "./api";

export async function validateEmail(email: string): Promise<AsyncResult<{ id: number, email: string }>> {
  const url = environment.api.share.emailValidate

  const response = await api.post(url, { email })
    .then(resp => resp?.data.success)
    .catch(() => null);

  if (!response) return { error: 'Email ou senha incorreto!' }

  return { success: response };
}

export async function sendEmailToResetPassword(email: string): Promise<AsyncResult<boolean>> {
  const url = environment.api.share.sendEmailToResetPassword;

  const response = await api.post(url, { email })
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })
    
  if (response.error) return { error: response.error }

  if (response.success) {
    return { success: response.success };
  }
}


export async function changePassword(token: string, email: string, password: string, confirmPassword: string): Promise<AsyncResult<boolean>> {
  const url = environment.api.share.sendTokenToResetPassword
    .replace('{token}', token)

  const payload = {
    password,
    email,
    confirmPassword
  }

  const response = await api.put(url, payload)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })

  if (response.error) return { error: response.error }

  if (response.success) {
    return { success: response.success };
  }
}
